import { COUNTRIES } from '@moda/portal-stanchions';
import { useCountry } from '../../components/CountrySelector';
import { useCookies } from '../useCookies';

export const useInEurope = () => {
  const {
    cookies: { cloudfrontViewerCountry }
  } = useCookies();
  const EUCountries = COUNTRIES.filter(country => country.continent === 'EUROPE');
  const EUCountriesNames = EUCountries.map(country => country.name.toLowerCase());
  const EUCountriesCodes = EUCountries.map(country => country.alpha2Code.toLowerCase());
  const {
    country: { alpha2Code }
  } = useCountry();
  const useInEurope =
    cloudfrontViewerCountry?.toLowerCase() === 'united kingdom' ||
    EUCountriesCodes.includes(alpha2Code.toLowerCase()) ||
    (cloudfrontViewerCountry && EUCountriesNames.includes(cloudfrontViewerCountry.toLowerCase()));
  return useInEurope;
};
